import $ from 'jquery';
import * as _ from 'lodash';

export default ({modelId, isSubscriber, model, ...configuration}) => {
    $(() => {
        const defaultConfig = {
            apiHost: window.initStore.env.SHOPPING_API_DOMAIN,
            apiKey: window.initStore.env.SHOPPING_API_KEY,
            shoppingPath: window.initStore.env.SHOPPING_API_PATH,
        };
        const config = {
            ...defaultConfig,
            ...configuration,
        };
        window.shoppingComponent.getShoppingData(modelId, config)
            .then((models) => {
                models.slice(0, 1).forEach((shoppingModel) => {
                    const mergedModel = {
                        ...model,
                        ...shoppingModel,
                    };

                    renderShoppingList(mergedModel, config);

                    addModalToShopButton(mergedModel);

                    if(isSubscriber) {
                        renderStickyFooter(mergedModel, config);
                    }
                });
                if (models && models.length) {
                    fireShoppingReadyEvent(models[0]);
                } else {
                    fireShoppingErrorEvent({modelId});
                }
            })
            .catch(() => fireShoppingErrorEvent({modelId}));
    });

    const addModalToShopButton = (mergedModel) => {
        const $modalPlaceholder = $('<div></div>');
        $(document.body).append($modalPlaceholder);

        $('#priceShopBtn').on('click', () => {
            window.shoppingComponent.renderShoppingOverlayByModel(
                $modalPlaceholder.get(0),
                mergedModel
            );
            document.dispatchEvent(new CustomEvent('shopping.changed'));
        });
    };

    const renderShoppingList = (mergedModel, config) => {
        window.shoppingComponent.renderShoppingListByModel(
            $(config.modelSellerDataSelector).get(0), mergedModel, config);
    };

    const renderStickyFooter = (mergedModel, config) => {
        if (window.innerWidth < 768) {
            window.shoppingComponent.renderPinnedShoppingFooter(
                mergedModel, config
            );
        }
    };

    const fireShoppingErrorEvent = (model) => {
        $(document).trigger('cro.products.price-and-shop', ['loadData-error', model]);
        document.dispatchEvent(new CustomEvent('shopping.changed'));
    };

    const fireShoppingReadyEvent = (model) => {
        $(document).trigger('cro.products.price-and-shop', ['loadData-model', model]);
        document.dispatchEvent(new CustomEvent('shopping.changed'));
    };
}

export const getBasePrice = (modelSelector) => {
    const basePrice = $(modelSelector).data('base-price');
    if (!_.startsWith(basePrice, '$')) {
        return '$' + basePrice;
    }
    return basePrice;
};

export const showPrice = (parent, modelSelector) => {
    $(parent).html(getBasePrice(modelSelector));
};

export const formatPrice = (price) => {
    try {
        return parseFloat(price).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    } catch (e) {
        return price;
    }
};

export const definePriceRange = (data) => {
    if (data.minPrice) {
        data.priceString = (data.minPrice !== data.maxPrice)
            ? ['$', formatPrice(data.minPrice.toFixed(2)), ' - ', '$', formatPrice(data.maxPrice.toFixed(2))].join('')
            : ('$' + formatPrice(data.minPrice.toFixed(2)));

        data.priceStringNoDecimals = (data.minPrice !== data.maxPrice)
            ? ['$', Math.round(data.minPrice), ' - ', '$', Math.round(data.maxPrice)].join('')
            : ('$' + Math.round(data.minPrice));
    }

    return data;
};



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/shared/PricingService/SharedWidgetPricingService.js